module.exports = __webpack_public_path__ + "static/media/origin-regs-logo.b16a1143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/origin-regs-logo.png
// module id = 815
// module chunks = 0